<template>
  <sidebar-layout>
    <template #top>
      <status-banner :text="i18n.t('events.show.cancelled')" icon="icon-cancel" status="danger" />
    </template>
  </sidebar-layout>
</template>

<script>
import SidebarLayout from '@/campaign-action-shared/sidebar-layout'
import StatusBanner from '@/campaign-action-shared/status-banner'

export default {
  components: { SidebarLayout, StatusBanner }
}
</script>
